export default __webpack_public_path__ + "static/media/8.f35cbf0c.jpg";